import angular from 'angular';

import WeatherGridFactory from './WeatherGridFactory';
import WeatherPanelComponent from './WeatherPanelComponent';
import WeatherPanelService from './WeatherPanelService';

export default angular
  .module('petroCloud.dashboard.weatherPanel', [])
  .factory('weatherGridFactory', WeatherGridFactory)
  .service('WeatherPanelService', WeatherPanelService)
  .component(WeatherPanelComponent.name, WeatherPanelComponent)
  .name;
